import { render, staticRenderFns } from "./status-progressing-closed.vue?vue&type=template&id=2060a2e1"
import script from "./status-progressing-closed.vue?vue&type=script&lang=js"
export * from "./status-progressing-closed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports